import { render, staticRenderFns } from "./Collapsable.vue?vue&type=template&id=14d28d99&scoped=true&"
import script from "./Collapsable.vue?vue&type=script&lang=js&"
export * from "./Collapsable.vue?vue&type=script&lang=js&"
import style0 from "./Collapsable.vue?vue&type=style&index=0&id=14d28d99&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d28d99",
  null
  
)

export default component.exports